// The header Free resources and Free webinars share (FreeResources.dc.html and FreeWebinars.dc.html,
// lines 26 to 57): the wordmark and a "Library" link back on the left; on the right, round buttons
// for search and the bell, and the account circle. Search opens its own box, across everything
// they own and everything free, with at most 5 results.
// Neither board has a phone version. On a phone it's PhoneLibrary's header as it is (the wordmark,
// search, the bell and the account circle, with no room for more at 390 wide), search and the bell
// open below it, full width, as they do in the Library, and the "Library" link starts the page
// (FreePage).
import { useRef, useState } from 'react'
import { Link } from '../lib/router.jsx'
import { initials as initialsOf } from '../lib/format.js'
import { searchIn } from '../library/search.js'
import { useOutside } from '../shell/Header.jsx'
import { Wordmark, SearchIcon, BellIcon } from '../shell/Marks.jsx'
import { BackArrow } from './Icons.jsx'

// "Library", with an arrow, back to the Library; or, given to and label, back to that page (a replay's
// own page goes back to Free webinars)
export function BackLink({ className = 'fp-back', to = '/', label = 'Library' }) {
  return <Link to={to} className={className}><BackArrow />{label}</Link>
}

const HINT_EMPTY = 'Everything you own, and everything free'
const HINT_TYPED = 'In everything you own, and everything free'
const NONE = 'Nothing matches that in anything you own.'

export function SubHeader({ model, person, phone, onOpenBell }) {
  const [panel, setPanel] = useState(null)
  const [q, setQ] = useState('')
  const ref = useRef(null)
  useOutside(ref, panel !== null && !phone, () => setPanel(null))

  const initials = model?.initials || initialsOf(person?.full_name)
  const term = q.trim()
  const results = model && term ? searchIn(model.search, q, 5) : []

  function toggle(which) {
    const next = panel === which ? null : which
    setPanel(next)
    if (next === 'bell' && onOpenBell) onOpenBell()
  }
  const close = () => { setPanel(null); setQ('') }

  const search = (
    <div className={phone ? 'fp-panel fp-panel--search' : 'fp-pop fp-pop--search'}>
      <input aria-label="Search everything you own" placeholder="Search everything you own" value={q}
        onChange={e => setQ(e.target.value)} autoFocus />
      <span className="fp-hint">{term ? HINT_TYPED : HINT_EMPTY}</span>
      {results.map(r => (
        <Link key={r.label + r.where} to={r.href} className="fp-row" onClick={close}>
          <span className="fp-row-label">{r.label}</span>
          <span className="fp-row-sub">{r.where}</span>
        </Link>
      ))}
      {term && model && results.length === 0 && <span className="fp-none">{NONE}</span>}
    </div>
  )
  const bell = (
    <div className={phone ? 'fp-panel fp-panel--bell' : 'fp-pop fp-pop--bell'}>
      <span className="fp-pop-head">Notifications</span>
      {(model?.notifications || []).map(n => (
        <Link key={n.id} to={n.href} className="fp-row fp-row--note" onClick={() => setPanel(null)}>
          <span className="fp-row-label fp-row-label--note">{n.text}</span>
          <span className="fp-row-sub">{n.when}</span>
        </Link>
      ))}
      {model && model.notifications.length === 0 && <span className="fp-none">Nothing new.</span>}
    </div>
  )

  const buttons = (
    <>
      <button type="button" className="fp-round" aria-label="Search everything you own" aria-expanded={panel === 'search'} onClick={() => toggle('search')}>
        <SearchIcon />
      </button>
      <button type="button" className="fp-round" aria-label="Notifications" aria-expanded={panel === 'bell'} onClick={() => toggle('bell')}>
        <BellIcon size={18} />
        {model?.hasUnread && <span className="fp-unread" aria-hidden="true" />}
      </button>
      <Link to="/account" className="fp-avatar" aria-label="Your account">{initials}</Link>
    </>
  )

  if (phone) {
    return (
      <>
        <header className="fp-header fp-header--phone">
          <Wordmark className="mark mark--phone" />
          <span className="fp-header-right">{buttons}</span>
        </header>
        {panel === 'search' && search}
        {panel === 'bell' && bell}
      </>
    )
  }
  return (
    <header className="fp-header">
      <div className="fp-header-left">
        <Wordmark className="mark mark--header" />
        <BackLink />
      </div>
      <div className="fp-header-right" ref={ref}>
        {buttons}
        {panel === 'search' && search}
        {panel === 'bell' && bell}
      </div>
    </header>
  )
}
